import analytics, { events } from '../../../shared/analytics';

import BasePage from '../../components/base-page/base-page';
import Carousel from '../../components/carousel/carousel';
import breakpoints from '../../config/breakpoints';

import './pricing-business.scss';

export default class PricingBusinessPage extends BasePage {
  ui = {
    ctaSection: '.js-pricing-cta-section',
    customOfferCta: '.js-custom-offer-cta',
    educationCta: '.js-education-cta',
    nonprofitCta: '.js-nonprofit-cta',
    testimonialsCarousel: '.js-testimonials-carousel',
  };

  events = {
    'click @ui.customOfferCta': 'handleCustomOfferCtaClick',
    'click @ui.educationCta': 'handleEducationCtaClick',
    'click @ui.nonprofitCta': 'handleNonprofitCtaClick',
  };

  onInit() {
    super.onInit();

    this.testimonialsCarousel = new Carousel({
      rootElement: this.ui.testimonialsCarousel,
      slidesPerPage: {
        [breakpoints.sm]: 2,
        [breakpoints.lg]: 3,
      },
    });

    this.testimonialsCarousel.init();

    if ('IntersectionObserver' in window) {
      this.ui.ctaSection.classList.add('pricing-personal__cta-section_shifted');
      const ctaSectionObserver = new IntersectionObserver(this.handleCtaSectionIntersection);
      ctaSectionObserver.observe(this.ui.ctaSection);
    }
  }

  handleCtaSectionIntersection = (entries) => {
    entries.forEach((entry) => {
      this.ui.ctaSection.classList.toggle('pricing-business__cta-section_shifted', !entry.isIntersecting);
    });
  };

  handleCustomOfferCtaClick() {
    analytics.trackEvent(events.CONTACT_SALES_CUSTOM);
  }

  handleEducationCtaClick() {
    analytics.trackEvent(events.CONTACT_SALES_EDU);
  }

  handleNonprofitCtaClick() {
    analytics.trackEvent(events.CONTACT_SALES_NONPROFIT);
  }
}

PricingBusinessPage.initOnDomLoaded();
